/* src/app/shared/components/splash/splash.component.scss */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
:host {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: var(--background_primary);
  opacity: 1;
  visibility: visible;
  transition: opacity 0.35s ease-in-out, visibility 0s linear 0s;
}
:host(.splash--hidden) {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.35s ease-in-out, visibility 0s linear 0.35s;
}
.splash-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 96px;
  height: 96px;
  transform: translate(-50%, -50%);
}
.splash-spinner__ring {
  position: absolute;
  border-radius: 50%;
  box-sizing: border-box;
  border-style: solid;
  border-color: transparent;
}
.splash-spinner__ring--outer {
  inset: 0;
  border-width: 4px;
  border-top-color: var(--highlight_primary);
  border-right-color: var(--highlight_primary);
  animation: splash-spin 1.6s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite;
}
.splash-spinner__ring--middle {
  inset: 14px;
  border-width: 3px;
  border-bottom-color: var(--highlight_secondary);
  border-left-color: var(--highlight_secondary);
  animation: splash-spin-reverse 1.1s linear infinite;
  opacity: 0.85;
}
.splash-spinner__ring--inner {
  inset: 28px;
  border-width: 2px;
  border-top-color: var(--highlight_primary);
  animation: splash-spin 0.9s ease-in-out infinite;
  opacity: 0.7;
}
.splash-spinner__core {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  margin: -5px 0 0 -5px;
  border-radius: 50%;
  background: var(--highlight_primary);
  box-shadow: 0 0 18px var(--highlight_primary);
  animation: splash-pulse 1.4s ease-in-out infinite;
}
@keyframes splash-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes splash-spin-reverse {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
@keyframes splash-pulse {
  0%, 100% {
    transform: scale(0.6);
    opacity: 0.55;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
}
/*# sourceMappingURL=splash.component.css.map */
